import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ConfigService } from './config.service';

@Injectable()
export class ServiceNewsService {
  constructor(private http: HttpClient, private configService: ConfigService) {}

  deleteNews(id): Observable<any> {
    const REST_URL = `${this.baseUrl()}/deleteNews`;
    return this.http.post(REST_URL, { id: id });
  }

  getNews(): Observable<any> {
    return this.http.get(`${this.baseUrl()}/getNews`);
  }

  updateNews(newsItem): Observable<any> {
    const REST_URL = `${this.baseUrl()}/updateNews`;
    return this.http.post(REST_URL, {
      id: newsItem.id,
      title: newsItem.title,
      summary: newsItem.summary,
      roles: newsItem.roles,
      display: newsItem.display,
      type: newsItem.type,
      fileName: newsItem.fileName,
      imageName: newsItem.imageName,
      files: newsItem.files
    });
  }

  createNews(newsItem): Observable<any> {
    const REST_URL = `${this.baseUrl()}/createNews`;
    return this.http.post(REST_URL, newsItem);
  }

  private baseUrl(): string {
    return `${this.configService.apiUrl()}/news`;
  }
}
